

TweenModel = Backbone.Model.extend({
  getTween: function (isReverse) {
    return this.get('tween')(isReverse);
  }
});

TweenCollection = Backbone.Collection.extend({
  model: TweenModel
});

var TweenManager = Backbone.View.extend({
  initialize: function (options) {
    var Property = Backbone.Model.extend({
      defaults: {
        currentId: null,
        enable: false
      }
    });
    this.model = new Property({currentId: options.currentId || null});
    this.tweens = new TweenCollection(options.tweens);

    // events
    this.listenTo(this.model, 'change:currentId', this.onChangeCurrent);
    this.listenTo(this.model, 'change:enable', function (model, enable) {this.trigger('tween:enable', enable); });
    this.listenTo(this, 'tween:change:sequence', this.onTweenChangeSequence);
    this.listenTo(this, 'tween:change:direct', this.onTweenChangeDirect);
    this.listenTo(this, 'tween:change:complete', this.onTweenChangeComplete);

    this.listenTo(this, 'scroll:limit', function (direction) {
      //console.log('scroll:limit', direction);
    });
  },
  /**
   * getEnable
   */
  getEnable: function(){
    return this.model.get('enable');
  },
  /**
   * setEnable
   */
  setEnable: function(value){
    return this.model.set('enable', this.is('Boolean', value) ? value : false);
  },
  /**
   * go
   */
  go: function (sceneId) {
    var current = this.getCurrent();
    var target = this.is('String', sceneId) ? this.getTweenModel(sceneId) : this.tweens.at(sceneId);
    if (target) {
      this.model.set('enable', false);
      this.model.set({'currentId': target.get('sceneId')});
    }
  },
  /**
   * prev
   */
  prev: function () {
    if (this.tweens.indexOf(this.getCurrent()) > 0) {
      var prevModel = this.tweens.at(this.tweens.indexOf(this.getCurrent()) - 1);
      this.model.set('enable', false);
      this.go(prevModel.get('sceneId'));
    } else {
      this.trigger('scroll:limit', 'prev');
      this.trigger('scroll:limit:prev');
    }
  },
  /**
   * next
   */
  next: function () {
    if (this.tweens.indexOf(this.getCurrent()) + 1 < this.tweens.length) {
      var nextModel = this.tweens.at(this.tweens.indexOf(this.getCurrent()) + 1);
      this.model.set('enable', false);
      this.go(nextModel.get('sceneId'));
    } else {
      this.trigger('scroll:limit', 'next');
      this.trigger('scroll:limit:next');
    }
  },
  /**
   * open
   */
  open: function(){
    this.model.set('enable', false);
    this.trigger('tween:open');
  },
  /**
   * close
   */
  close: function(){
    this.model.set('enable', false);
    this.trigger('tween:close');
  },
  /**
   * getTweenModel
   */
  getTweenModel: function (sceneId) {
    return this.tweens.findWhere({sceneId: sceneId});
  },
  /**
   * getCurrent
   */
  getCurrent: function () {
    return this.getTweenModel(this.model.get('currentId'));
  },
  /**
   * onChangeCurrent
   */
  onChangeCurrent: function (model, currentId) {
    var current = this.getCurrent();
    var prev = this.getTweenModel(model.previous('currentId'));
    var isReverse = !(this.tweens.indexOf(current) > this.tweens.indexOf(prev));
    var isSequence = (Math.abs(this.tweens.indexOf(current) - this.tweens.indexOf(prev))) == 1;
    if (isSequence) {
      this.trigger('tween:change:sequence', model, currentId, model.previous('currentId'), isReverse, isSequence);
    } else {
      this.trigger('tween:change:direct', model, currentId, model.previous('currentId'), isReverse, isSequence);
    }
  },
  /**
   * onTweenChangeSequence
   */
  onTweenChangeSequence: function (model, currentId, prevId, isReverse, isSequence) {
    var current = this.getCurrent();
    var prev = this.getTweenModel(prevId);
    var timeline = new TimelineMax({
      paused: true,
      onComplete: _.bind(function () {
        this.trigger('tween:change:complete');
      }, this)
    });

    // isSequence
    if (!isReverse) {
      // next
      timeline.add([current.getTween(isReverse)]);
    } else {
      // prev
      var prevTween = prev.getTween(isReverse).reverse(0);
      timeline.add([prevTween]);
      timeline.addCallback(function () {
        var currentTween = current.getTween(isReverse);
        currentTween.seek(currentTween.totalDuration(), false);
      }, prevTween.totalDuration());
    }
    timeline.play();
  },
  /**
   * onTweenChangeDirect
   */
  onTweenChangeDirect: function (model, currentId, prevId, isReverse, isSequence) {
    var current = this.getCurrent();
    var prev = this.getTweenModel(prevId);
    if (!prevId) {
      /**
       * 初回時
       */
      var opening_timeline = new TimelineMax({
        paused: true,
        onComplete: _.bind(function () {
          this.trigger('tween:change:complete');
        }, this)
      });
      this.tweens.every(_.bind(function (tweenModel, index, list) {
        if (tweenModel === current) {
          return false;
        } else {
          var tween = tweenModel.getTween(isReverse);
          opening_timeline.add([tween]);
          return true;
        }
      }, this));
      var currentTween = current.getTween(isReverse);
      opening_timeline.add([currentTween]);
      //opening_timeline.seek(opening_timeline.totalDuration() - currentTween.totalDuration(), false);
      opening_timeline.seek(opening_timeline.totalDuration(), false);
      opening_timeline.play();

    } else {
      /**
       * ダイレクト
       */
      var switch_timeline = new TimelineMax({
        paused: true,
        repeat: 1,
        yoyo: true,
        onRepeat: _.bind(function () {
          var timeline = new TimelineMax({
            paused: true
          });

          var models = [];
          var startIndex = Math.min(this.tweens.indexOf(prev), this.tweens.indexOf(current));
          var endIndex = Math.max(this.tweens.indexOf(prev), this.tweens.indexOf(current));
          this.tweens.each(_.bind(function (tweenModel, index, list) {
            if (startIndex < index && index <= endIndex) models.push(tweenModel);
          }));
          if (!isReverse) {
            // 順方向
            _.each(models, _.bind(function (tweenModel, index, list) {
              timeline.add([tweenModel.getTween(isReverse)]);
            }));
          } else {
            // 逆方向
            models.reverse();
            _.each(models, _.bind(function (tweenModel, index, list) {
              timeline.add([tweenModel.getTween(isReverse).reverse(0)]);
            }));
          }
          timeline.addCallback(function () {
            var currentTween = current.getTween(isReverse);
            currentTween.seek(currentTween.totalDuration(), false);
          }, timeline.totalDuration());
          timeline.seek(timeline.totalDuration(), false);

        }, this),
        onComplete: _.bind(function () {
          this.trigger('tween:change:complete');
        }, this)
      });

      switch_timeline.add(TweenMax.to(this.el, 0.5, { scale: 0.92, opacity: 0, ease: Cubic.easeInOut }));

      switch_timeline.play();
    }
  },
  /**
   * onTweenChangeComplete
   */
  onTweenChangeComplete: function () {
    this.model.set({'enable': true});
  },
  /**
   * is
   */
  is: function (type, obj) {
    var _class = Object.prototype.toString.call(obj).slice(8, -1);
    return obj !== undefined && obj !== null && _class === type;
  }
});